export const isSnippetTypeAFile = (snippetType: string) =>
  ["PDF", "TXT", "SRT"].includes(snippetType);
